 var handle = window.productHandle;

const KonfigTracking = (() => {

  // ── KONFIGURATION ─────────────────────────────────────────
  const WP_URL  = 'https://dashboard.mirrored.pro/';
  const API_KEY = 'testkey';
  const KONFIG  = handle; // ← pro Kunde anpassen
  const USER_ID = 6;            // ← WP User ID des Kunden

  // ── SESSION STATE ─────────────────────────────────────────
  const SESSION_ID    = 'sess-' + Math.random().toString(36).substr(2, 9);
  const SESSION_START = { time: null };
  let   _endFired     = false; // doppeltes Feuern verhindern

  // ── DEVICE ────────────────────────────────────────────────
  function getDevice() {
    const ua = navigator.userAgent;
    if (/iPhone|iPad|iPod/.test(ua)) return 'ios';
    if (/Android/.test(ua)) return 'android';
    return 'desktop';
  }

  // ── SEND ──────────────────────────────────────────────────
  function send(element_key, event_type, duration_ms = 0, cart_value = 0) {
    const payload = JSON.stringify({
      user_id:      USER_ID,
      konfigurator: KONFIG,
      element_key,
      event_type,
      duration_ms,
      cart_value,
      device:       getDevice(),
      page_url:     window.location.href,
      session_id:   SESSION_ID,
    });

    // fetch primär
    fetch(`${WP_URL}/wp-json/konfig/v1/track`, {
      method:  'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Konfig-Key': API_KEY,
      },
      body: payload,
    }).catch(() => {
      // Fallback: sendBeacon wenn fetch fehlschlägt
      navigator.sendBeacon(
        `${WP_URL}/wp-json/konfig/v1/track`,
        new Blob([payload], { type: 'application/json' })
      );
    });
  }

  // ── END SESSION ───────────────────────────────────────────
  function endSession() {
    // Doppeltes Feuern verhindern
    if (!SESSION_START.time || _endFired) return;
    _endFired = true;

    const duration_ms = Date.now() - SESSION_START.time;
    SESSION_START.time = null;

    const payload = JSON.stringify({
      user_id:      USER_ID,
      konfigurator: KONFIG,
      element_key:  'session:close',
      event_type:   'dwell',
      duration_ms:  duration_ms,
      cart_value:   0,
      device:       getDevice(),
      page_url:     window.location.href,
      session_id:   SESSION_ID,
    });

    // fetch primär
    fetch(`${WP_URL}/wp-json/konfig/v1/track`, {
      method:  'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Konfig-Key': API_KEY,
      },
      body: payload,
    }).catch(() => {
      // Fallback: sendBeacon
      navigator.sendBeacon(
        `${WP_URL}/wp-json/konfig/v1/track`,
        new Blob([payload], { type: 'application/json' })
      );
    });
  }

  function onVisibilityChange() {
    if (document.visibilityState === 'hidden') endSession();
  }

  function init() {
    SESSION_START.time = Date.now();
    _endFired = false;
    send('session:start', 'click');
    window.removeEventListener('beforeunload', endSession);
    document.removeEventListener('visibilitychange', onVisibilityChange);
    window.addEventListener('beforeunload', endSession, { once: true });
    document.addEventListener('visibilitychange', onVisibilityChange, { once: true });
  }

  // ── TRACK CLICK ───────────────────────────────────────────
  function track(category, value, cartValue = 0) {
    const element_key = ['addcart', 'ar:start', 'session:close'].includes(category)
      ? category
      : `${category}:${value}`;
    send(element_key, 'click', 0, cartValue);
  }

  // ── TRACK DWELL ───────────────────────────────────────────
  function trackDwell(category, value, startTime) {
    const ms = Date.now() - startTime;
    if (ms < 500) return; // unter 0.5s ignorieren
    send(`${category}:${value}`, 'dwell', ms);
  }

  // ── EXPORT ────────────────────────────────────────────────
  return { init, track, trackDwell, endSession };

})();



(function () {
  const controllers = new Map();
  let subscribed = false;

  function init3d(root) {
    const gallery = root.closest('media-gallery');
    const opener = gallery && gallery.querySelector('#open3d');
    const dialog = root.querySelector('[data-dialog="3"]');
    if (!opener || !dialog || controllers.has(root)) return;

    const viewer = root.querySelector('model-viewer#framebag');
    const qr = root.querySelector('#qr');
    const content = root.querySelector('#clx-content3d');
    const listeners = [];
    let timer = null;
    let tracking = false;

    function listen(element, name, handler) {
      if (!element) return;
      element.addEventListener(name, handler);
      listeners.push(() => element.removeEventListener(name, handler));
    }

    function endSession() {
      if (!tracking) return;
      tracking = false;
      KonfigTracking.endSession();
    }

    function closeModal() {
      if (timer !== null) {
        clearTimeout(timer);
        timer = null;
      }
      if (dialog.open) dialog.close();
      endSession();
    }

    function openModal() {
      if (!root.isConnected || dialog.open || timer !== null) return;
      KonfigTracking.init();
      tracking = true;
      if (typeof dialog.showModal === 'function') {
        timer = setTimeout(() => {
          timer = null;
          if (!root.isConnected) {
            endSession();
            return;
          }
          dialog.showModal();
        }, 400);
      } else {
        dialog.setAttribute('open', 'open');
      }
    }

    function showQR(show) {
      if (qr) qr.style.display = show ? 'flex' : 'none';
      if (content) content.style.display = show ? 'none' : 'block';
    }

    listen(opener, 'click', openModal);
    listen(root.querySelector('[data-close="3"]'), 'click', closeModal);
    listen(dialog, 'keydown', event => {
      if (event.key === 'Escape') closeModal();
    });
    listen(dialog, 'close', endSession);
    for (const [selector, label] of [['#colW', 'Light Grey'], ['#colB', 'Black']]) {
      listen(root.querySelector(selector), 'click', event => {
        if (!viewer) return;
        viewer.variantName = event.currentTarget.value === 'default' ? null : event.currentTarget.value;
        KonfigTracking.track('Farbe', label);
      });
    }
    listen(root.querySelector('#toggle'), 'click', () => {
      KonfigTracking.track('ar:start', 'ar:start');
      showQR(true);
    });
    listen(root.querySelector('#closeqr'), 'click', () => showQR(false));
    listen(root.querySelector('#launchAR'), 'click', () => {
      showQR(false);
      if (viewer && typeof viewer.activateAR === 'function') viewer.activateAR();
    });

    controllers.set(root, () => {
      closeModal();
      listeners.forEach(remove => remove());
    });
  }

  function init() {
    for (const [root, destroy] of controllers) {
      if (!root.isConnected) {
        destroy();
        controllers.delete(root);
      }
    }
    document.querySelectorAll('[data-clx-gallery="3"]').forEach(init3d);
    const pubsub = window.theme && window.theme.pubsub;
    if (!subscribed && pubsub) {
      pubsub.subscribe(pubsub.PUB_SUB_EVENTS.variantChange, init);
      subscribed = true;
    }
  }

  init();
  if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', init, { once: true });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
})();
